import QuickSelectRoot from './components/quick-select-root'
import QuickSelectLabel from './components/quick-select-label'
import QuickSelectList from './components/quick-select-list'
import QuickSelectItem from './components/quick-select-item'
import QuickSelectRecursiveList from './components/quick-select-recursive-list'
import QuickSelectFolderItem from './components/quick-select-folder-item.jsx'
import QuickSelectLoadingItem from './components/quick-select-loading-item.js'

const QuickSelectComponent = {
  Root: QuickSelectRoot,
  Label: QuickSelectLabel,
  List: QuickSelectList,
  Item: QuickSelectItem,
  RecursiveList: QuickSelectRecursiveList,
  FolderItem: QuickSelectFolderItem,
  LoadingItem: QuickSelectLoadingItem
}

export default QuickSelectComponent
